{
  "version": 1,
  "asset_id": "f5105835-bb66-4a18-b5bf-00f21e134e71",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f5105835-bb66-4a18-b5bf-00f21e134e71/team-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f5105835-bb66-4a18-b5bf-00f21e134e71/team-1280.webp",
  "original_filename": "team-1280.webp",
  "size": 37164,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:27:01Z"
}
